import { render, staticRenderFns } from "./DialogoDeTrocaDeTelaDaLoja.vue?vue&type=template&id=1c7e03ae&"
import script from "./DialogoDeTrocaDeTelaDaLoja.vue?vue&type=script&lang=ts&"
export * from "./DialogoDeTrocaDeTelaDaLoja.vue?vue&type=script&lang=ts&"
import style0 from "./DialogoDeTrocaDeTelaDaLoja.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog})
